import(/* webpackMode: "eager", webpackExports: ["WebVitals"] */ "/Users/green/Code/_worktrees/aideco-deploy-1022/apps/web/src/components/performance/WebVitals.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ReplayBootstrap"] */ "/Users/green/Code/_worktrees/aideco-deploy-1022/apps/web/src/components/sentry/ReplayBootstrap.tsx");
